import PublicAuth from './PublicAuth';
import ClientSettings from './ClientSettings';
import ClientFilters from './ClientFilters';
import ClientLanguage from './ClientLanguage';
import OpeningHours from './OpeningHours';
import CurrentLocation from './CurrentLocation';
import Categories from './Categories';
import UserDetails from './UserDetails';
import DataCategoryAll from './DataCategoryAll';
import CountryList from './CountryList';
import AdditionalCharges from './AdditionalCharges';
import CartLocation from './CartLocation';
import UserData from './UserData';
import CityList from './CityList';
import OrderDetails from './OrderDetails';
import CheckoutStatus from './CheckoutStatus';
import DiscountCode from './DiscountCode';
import CartId from './CartId';
import TemplateList from './TemplateList';

export default {
	PublicAuth,
	ClientSettings,
	ClientFilters,
	ClientLanguage,
	OpeningHours,
	CurrentLocation,
	Categories,
	UserDetails,
	DataCategoryAll,
	CountryList,
	AdditionalCharges,
	CartLocation,
	UserData,
	CityList,
	OrderDetails,
	CheckoutStatus,
	DiscountCode,
	CartId,
	TemplateList
};